import React from "react";
import MemorialRibbon from "@/components/MemorialRibbon";
import { RotateCcw, BookOpen } from "lucide-react";

const MEMORIAL_NOTE =
  "A total of 2,763 people died at the Twin Towers when they collapsed during the September 11 attacks. This includes 343 firefighters and paramedics, 23 New York City police officers (NYPD), and 37 Port Authority police officers. We will never forget.";

export default function LegacyScreen({ onReplay, onFactCheck }) {
  return (
    <div data-testid="legacy-memorial-screen" className="tab-fade" style={{ position: "absolute", inset: 0, zIndex: 50, overflowY: "auto" }}>
      {/* American flag commemorative background — bright & vibrant */}
      <div style={{ position: "absolute", inset: 0, backgroundImage: "url(/brand/american_flag.jpg)", backgroundSize: "cover", backgroundPosition: "center", opacity: 0.92, filter: "saturate(1.3) brightness(1.1)" }} />
      <div style={{ position: "absolute", inset: 0, background: "rgba(7,9,13,0.3)" }} />

      <div style={{ position: "relative", zIndex: 1, minHeight: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", padding: "60px 24px 48px" }}>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 16, textAlign: "center", maxWidth: 700, padding: "40px 30px 34px", borderRadius: 14, overflow: "visible", background: "rgba(8,10,14,0.42)", backdropFilter: "blur(6px)", boxShadow: "0 24px 80px rgba(0,0,0,0.5)", border: "1px solid rgba(201,162,75,0.35)" }}>
        <div style={{ overflow: "visible", filter: "drop-shadow(0 6px 18px rgba(0,0,0,0.9))" }}>
          <MemorialRibbon size={66} />
        </div>
        <div style={{ fontSize: 11, letterSpacing: "0.32em", textTransform: "uppercase", color: "#6fe39a", textShadow: "0 2px 12px rgba(0,0,0,0.9)" }}>
          Egress Complete · Street Level Reached
        </div>
        <h1 className="font-serif-q" style={{ margin: 0, color: "#ffd968", fontSize: "clamp(34px,6vw,64px)", fontWeight: 700, textShadow: "0 3px 22px rgba(0,0,0,0.95), 0 1px 2px rgba(0,0,0,1)" }}>
          Immaculate Salvation
        </h1>
        <p className="font-garamond" style={{ color: "#ffffff", fontSize: 21, fontStyle: "italic", lineHeight: 1.6, maxWidth: 620, margin: "2px 0 0", fontWeight: 600, textShadow: "0 2px 16px rgba(0,0,0,0.95)" }}>
          Brian and Stanley successfully escaped that day.
        </p>
        <p className="font-garamond" style={{ color: "#f5f2ea", fontSize: 16.5, fontStyle: "italic", lineHeight: 1.6, maxWidth: 620, margin: 0, textShadow: "0 2px 12px rgba(0,0,0,0.9)" }}>
          Strangers at 9:03 a.m., they descended Stairwell A together and emerged into daylight moments before
          the South Tower fell. They left as brothers.
        </p>
        <p className="font-garamond" data-testid="legacy-memorial-note" style={{ color: "#f2ede2", fontSize: 16, lineHeight: 1.75, maxWidth: 640, margin: "6px 0 4px", fontWeight: 500, textShadow: "0 1px 10px rgba(0,0,0,0.92)" }}>
          {MEMORIAL_NOTE}
        </p>

        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", marginTop: 8 }}>
          {onFactCheck && (
            <button data-testid="legacy-fact-check-button" onClick={onFactCheck} className="ghost-btn" style={{ padding: "13px 24px", borderRadius: 4, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 8 }}>
              <BookOpen size={15} /> View Bibliography
            </button>
          )}
          <button data-testid="legacy-replay-button" onClick={onReplay} className="gold-btn" style={{ padding: "14px 30px", borderRadius: 4, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 9 }}>
            <RotateCcw size={16} /> Return to Start
          </button>
        </div>
        </div>
      </div>
    </div>
  );
}
